<template>
  <list-default ref="list" :resolver="resolver" @updateList="updateList" />
</template>

<script>
import ListDefault from '../../../cadastro/components/ListDefault'
import resolver from './resolver'

export default {
  name: 'ListTribunais',
  components: {ListDefault},
  computed: {
    resolver () {
      return resolver
    }
  },
  methods: {
    updateList () {
      console.log('List is updating...')
      this.$refs.list.load()
    },
    excluir () {
      console.log('Allons-y!!')
    }
  }
}
</script>

<style scoped>

</style>
